export class AccessSession {
    public checking = true;
    public authenticated = false;
    public username = '';
    public password = '';
    public account = '';
    public accessKind = '';
    public clientBinding = '';
    public expiresAt = '';
    public busy = false;
    public message = '';

    private async request(path: string, method = 'GET', body?: any) {
        const response = await fetch('/api/saju/auth/' + path, {
            method, cache: 'no-store', credentials: 'include',
            headers: body ? { 'Content-Type': 'application/json' } : {},
            body: body ? JSON.stringify(body) : undefined
        });
        let result: any = {};
        try { result = await response.json(); } catch {}
        if (!response.ok) throw Object.assign(new Error(result.message || '로그인 요청을 확인하지 못했습니다.'), { status: response.status });
        return result.data;
    }

    private accept(data: any) {
        this.authenticated = data?.authenticated === true;
        this.account = data?.username || '';
        this.accessKind = data?.access_kind || '';
        this.clientBinding = data?.client_binding || '';
        this.expiresAt = data?.expires_at || '';
        this.password = '';
        this.message = '';
    }

    public async restore() {
        this.checking = true;
        try { this.accept(await this.request('session')); }
        catch (error: any) {
            this.clear();
            if (error.status !== 401) this.message = '로그인 상태를 확인하지 못했습니다. 잠시 뒤 다시 시도해 주세요.';
        } finally { this.checking = false; }
        return this.authenticated;
    }

    public async login() {
        if (this.busy || !this.username || !this.password) return false;
        this.busy = true; this.message = '';
        try {
            this.accept(await this.request('login', 'POST', { username: this.username, password: this.password }));
            return true;
        } catch (error: any) {
            this.password = '';
            this.message = error.status === 401 ? '계정 이름 또는 비밀번호를 확인해 주세요.' : error.message;
            return false;
        } finally { this.busy = false; }
    }

    public async logout() {
        this.busy = true;
        try { await this.request('logout', 'POST'); }
        catch { /* Local private state is still cleared; the expired cookie is cleared by the server on 401. */ }
        finally { this.clear(); this.busy = false; }
    }

    public expired() {
        this.clear();
        this.message = '로그인이 만료되었습니다. 이 화면에서 다시 로그인하면 이어서 이용할 수 있습니다.';
    }

    private clear() {
        this.authenticated = false; this.account = ''; this.accessKind = '';
        this.clientBinding = ''; this.expiresAt = ''; this.password = '';
    }
}
